import {HandLandmarker} from '@mediapipe/tasks-vision'

export const createHandLandmarker = async (vision) => {
    return await HandLandmarker.createFromOptions(vision, {
        baseOptions: {
            modelAssetPath: `https://storage.googleapis.com/mediapipe-models/hand_landmarker/hand_landmarker/float16/1/hand_landmarker.task`,
            delegate: "GPU"
        },
        runningMode: 'IMAGE',
        numHands: 4
    });
};
